var _rect, _rect2, _rect3, _path, _rect4, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayOnDesktopMax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 12,
    fill: "#DDEBF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 60,
    height: 48,
    rx: 5.33333,
    fill: "#9BC6F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3333,
    y: 18.6663,
    width: 51.3333,
    height: 40.6667,
    rx: 2.33333,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.666667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3335 71.667L37.0002 61.667H52.6668L54.0002 71.667H35.3335Z",
    fill: "#9BC6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6665,
    y: 71.667,
    width: 30.6667,
    height: 3.33333,
    rx: 1.66667,
    fill: "#9BC6F0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.25,
    cy: 39.25,
    r: 11.25,
    fill: "#1795F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9971 41.5516V36.9484C42.9971 36.4166 43.5386 36.0805 43.9793 36.3388L47.907 38.6404C48.3604 38.9061 48.3604 39.5939 47.907 39.8596L43.9793 42.1612C43.5386 42.4195 42.9971 42.0834 42.9971 41.5516Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOnDesktopMax);
export default __webpack_public_path__ + "static/media/playOnDesktopMax.cbbbf78f.svg";
export { ForwardRef as ReactComponent };